var _style, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGmailLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "25px",
    height: "auto",
    viewBox: "0 0 30 30",
    id: "Layer_1",
    xmlSpace: "preserve",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#FD6A7E;}\n\t.st1{fill:#17B978;}\n\t.st2{fill:#8797EE;}\n\t.st3{fill:#41A6F9;}\n\t.st4{fill:#37E0FF;}\n\t.st5{fill:#2FD9B9;}\n\t.st6{fill:#F498BD;}\n\t.st7{fill:#FFDF1D;}\n\t.st8{fill:#C6C9CC;}\n")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M25,6H5C3.9,6,3,6.9,3,8v14c0,1.1,0.9,2,2,2h20c1.1,0,2-0.9,2-2V8C27,6.9,26.1,6,25,6z M23.8,10l-8.1,6.4  c-0.4,0.3-1,0.3-1.5,0l-8-6.3C5.9,9.9,5.8,9.4,6.1,9c0.3-0.3,0.7-0.4,1.1-0.2L15,14l7.9-5.2c0.4-0.2,0.9-0.1,1.1,0.2  C24.2,9.3,24.1,9.8,23.8,10z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGmailLogo);
export default __webpack_public_path__ + "static/media/gmailLogo.53736003a5bf02e6d9b9f2f76fe6086f.svg";
export { ForwardRef as ReactComponent };